import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: "center",
    '& .MuiGrid-root': {
      margin: "24px 0"
    },
    '& .MuiInput-root': {
      alignItems: "baseline",
      padding: 0
    },
    '& .MuiTypography-root': {
      overflowWrap: "unset"
    },
  },
  wrapper: {
    margin: theme.spacing(1, 0),
    position: "relative"
  }
}));

const divSubmitStyle = makeStyles(() => ({
  buttonStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    position: "sticky",
    background: "#FFFFFF",
    top: 1,
    bottom: "-30px",
    zIndex: 10,
  },
  dashboardButtonStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    position: "sticky",
    background: "#FFFFFF",
    top: 1,
    bottom: "-30px",
    zIndex: 10,
    margin: "30px 0"
  },
}));

export default function CancelSuccess(props) {
  const { handleSuccessCancel } = props;
  const classes = useStyles();
  const buttonStyle = divSubmitStyle();

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        className={classes.root}
      >
        <Typography style={{
          paddingTop: "30px",
          fontSize: "35px",
          fontWeight: "bold"
        }} gutterBottom>
          Thank you.
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        className={classes.root}
      >
        <Typography
          gutterBottom
          style={{
            margin: "20px 0 10px 0",
            fontSize: "25px"
          }}>
          Your appointment has been successfully cancelled.
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        className={buttonStyle.dashboardButtonStyle}
      >
        <div className={classes.wrapper}>
          <Button
            onClick={handleSuccessCancel}
            variant="contained"
            color="primary"
            role="button"
          >
            Go to My Dashboard
          </Button>
        </div>
      </Grid>
    </React.Fragment>
  );
};
